// Enums
import { DATA_SOURCE_TAB_CATEGORY } from '@/enums/DataSource';

// Types
import User from '@/types/user';
import { DataSourceTabs as DataSourceTabsType } from '@/types/app-config';

//
/**
 * Filters and returns the data source tabs based on the user's configuration, tab category,
 * and whether post messages are active.
 *
 * @param user
 * @param tabCategory
 * @param isPostMessageActive
 *
 * @returns An array of filtered data source tabs of the specified category, or null if no tabs are available.
 */
export const getFilteredDataSourceTabs = (
  user: User | null | undefined,
  tabCategory: DATA_SOURCE_TAB_CATEGORY,
  isPostMessageActive: boolean,
): DataSourceTabsType[] | null =>
  user?.appConfig.dataSourceTabs?.[tabCategory]?.filter(tab => {
    const isTabPostMessage = tab.isPostMessage;

    // If post messages are not active: don't show the post message tab
    if (!isPostMessageActive && isTabPostMessage) {
      return false;
    }

    return true;
  }) || null;
